<template>
  <div id="app">
    <div>
      <video ref="video" id="video" width="640" height="480" autoplay></video>
    </div>
    <div>
      <button id="snap" v-on:click="capture()">Snap Photo</button>
    </div>
    <img>
  </div>
</template>

<script>
export default {
  name: "Camera",
  data() {
    return {
      video: {},
      canvas: {}
    };
  },
  mounted() {
    this.video = this.$refs.video;

    // Prefer camera resolution nearest to 1280x720.
    var constraints = { audio: false, video: { width: 1280, height: 720 } };

    navigator.mediaDevices
      .getUserMedia(constraints)
      .then(function(mediaStream) {
        var video = document.querySelector("video");
        video.srcObject = mediaStream;
        video.onloadedmetadata = function(e) {
          video.play();
        };
      })
      .catch(function(err) {
        console.log(err.name + ": " + err.message);
      });
  },
  methods: {
    capture() {
      navigator.mediaDevices
        .getUserMedia({ video: true })
        .then(gotMedia)
        .catch(error => console.error("getUserMedia() error:", error));

      function gotMedia(mediaStream) {
        const mediaStreamTrack = mediaStream.getVideoTracks()[0];
        const imageCapture = new ImageCapture(mediaStreamTrack);

        imageCapture
          .takePhoto()
          .then(blob => {
            console.log(URL.createObjectURL(blob));
            console.log(blob);
            let src;

            const imageUrl = URL.createObjectURL(blob);
            src = imageUrl;

            var img = document.createElement("img");
            img.src = src;
            document.body.appendChild(img);
          })
          .catch(error => console.error("takePhoto() error:", error));
      }
    }
  }
};
</script>

<style>
#canvas {
  display: none;
}
li {
  display: inline;
  padding: 5px;
}
</style>